/**
* src/web/components/attachment-file.jsx
* 画像ファイル以外のファイル(例：exls, pdf, 音声ファイル)
*/
import React from 'react'
import connect from '../../connects/attachment-file'
import attachmentsTheme from './themes/attachments.css'
import attachmentsThumbnailTheme from './themes/attachments-thumbnail.css'
import Tooltip from 'react-toolbox/lib/tooltip'
import Avatar from 'react-toolbox/lib/avatar'
import Chip from 'react-toolbox/lib/chip'
import Link from 'react-toolbox/lib/link'
import { uploadFileFailed } from '../../actions/upload-file';
import classnames from 'classnames'
import PdfPreviewDialog from './pdf-preview-dialog'

const TooltipLink = Tooltip(Link)

class AttachmentFile extends React.Component {
  constructor(props) {
    super(props)
    this.state = { tooltipImg: this.props.file.file.thumb_url && this.props.file.content_type == 'application/pdf' }
  }

  // PDFのサムネイル画像を表示しようとしてエラーになった場合はTooltipを消す
  onTooltipImgError = ()=> this.setState({ tooltipImg: false })
  onClick = ()=> {
    if (this.props.file.content_type.match(/^audio/))
      this.props.showVoicePlayer(this.props.file, this.props.diary_id, this.props.comment_id)
    else if (this.props.chat && this.props.file.content_type == 'application/pdf')
      this.props.updateUI({ openDialog: true })
    else if (!this.props.chat && this.props.file.content_type == 'application/pdf')
      this.props.showPdfPreview(this.props.file)
  }
  onClose = () => {
    this.props.updateUI({ openDialog: false })
  }

  render() {
    const {
      t,
      file,
      ui,
      showPdfPreview,
      showAttachments,
      showVoicePlayer,
      noTooltip,
      chat,
      diary_id,
      comment_id,
    } = this.props

    const num = file && file.name.lastIndexOf('.')
    const basename = num != -1 && file.name.slice(0, num) || file.name
    const extension = num != -1 && file.name.slice(num + 1, file.name.length).toLowerCase() || ''
    // ファイル名が長い場合は途中を...で省略する
    const filename = (basename.length > 10 ? basename.slice(0, 10) + '...' + extension : file.name)

    const isPdf = extension == 'pdf' ? true : false
    const isAudio = file.content_type.match(/^audio/) ? true : false
    const icon = isPdf && 'picture_as_pdf' || isAudio && file.status == 'committed' && 'audiotrack' || 'attach_file'

    if (!noTooltip && this.state.tooltipImg) // Tooltipでサムネイルを表示する
      return (
        <TooltipLink tooltipPosition="vertical"
            theme={attachmentsThumbnailTheme}
            style={{ display: 'inline', cursor: 'pointer' }}
            tooltip={<img src={file.file.thumb_url} style={{ width: '100%' }} onError={this.onTooltipImgError} />}
            onClick={this.onClick} >
          <Chip className={attachmentsTheme.chip}>
            <Avatar className={classnames(attachmentsTheme.avatar, icon)} icon={icon} />
            {filename}
          </Chip>
        </TooltipLink>
      )
    if (basename.length > 10) // Tooltipにファイル名全体を表示する
      return (
        <div>
        {chat && ui.openDialog && <PdfPreviewDialog open={ui.openDialog} onClose={this.onClose} t={t} file={file}/>}
        <TooltipLink tooltipPosition="vertical"
            href={isPdf || isAudio ? undefined : file.file.url}
            target={"_blank"}
            rel={"noopener noreferrer"}
            style={{ display: 'inline', cursor: 'pointer' }}
            tooltip={file.name}
            theme={attachmentsTheme}
            download={!file.status && true || false}
            onClick={this.onClick} >
          <Chip className={attachmentsTheme.chip}>
            <Avatar className={file.status && file.status != 'committed' ? undefined : classnames(attachmentsTheme.avatar, icon)} icon={icon} />
            {filename}
          </Chip>
        </TooltipLink>
        </div>
      )
    else // それ以外の場合はLinkで表示する
      return (
        <div>
        {chat && ui.openDialog && <PdfPreviewDialog open={ui.openDialog} onClose={this.onClose} t={t} file={file}/>}
        <Link
            href={isPdf || isAudio ? undefined : file.file.url}
            target={"_blank"}
            rel={"noopener noreferrer"}
            style={{ display: 'inline', cursor: 'pointer' }}
            theme={attachmentsTheme}
            download={!file.status && true || false}
            onClick={this.onClick} >
          <Chip className={attachmentsTheme.chip}>
            <Avatar className={file.status && file.status != 'committed' ? undefined : classnames(attachmentsTheme.avatar, icon)} icon={icon} />
            {filename}
          </Chip>
        </Link>
        </div>
      )
  }
}

export default connect(AttachmentFile)


// WEBPACK FOOTER //
// ./src/web/components/attachment-file.jsx